<!--  -->
<template>
  <div>
    <div v-show="show" class="task-list">
      <div class="content">
        <div class="title">
          <div class="box">完成任务获取抽卡次数</div>
          <div class="close" @click="changeShow"></div>
        </div>
        <div class="section">
          <div class="emptyData" v-if="!activityId">
            <img
              src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/coll_qs.png"
              alt=""
            />
            <p>该活动已下架~</p>
          </div>
          <div class="list" v-for="(item, k) in taskList" :key="k" @click="openTask(item)">
            <img class="icon" :src="item.icon" />
            <div class="desc">
              <h1>
                {{ item.title }}
                <span v-if="item.taskType === 'BASIC4'"
                  >({{ item.pullCount || 0 }}/{{ item.finishCount }})</span
                >
              </h1>
              <h2>{{ item.subtitle }}</h2>
            </div>
            <button class="btn" :class="{ disabled: item.isFinish }">
              {{ item.isFinish ? '已完成' : item.btnTxt }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <OfficialAccount ref="officialAccount" />
    <PullNew ref="pullNew" :activityId="activityId" :currentTask="currentTask" />
    <DownApp ref="downApp" :activityId="activityId" :currentTask="currentTask" />
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
import OfficialAccount from './officialAccount.vue';
import PullNew from './pullNew.vue';
import DownApp from './downApp.vue';

export default {
  components: {
    OfficialAccount,
    PullNew,
    DownApp,
  },
  data() {
    return {
      isApp: this.$root.isApp,
      miniprogram: this.$root.miniprogram,
      show: false,
      currentTask: {},
    };
  },
  props: {
    taskList: {
      type: Array,
      default: () => [],
    },
    activityId: {
      type: Number,
      default: 0,
    },
  },
  computed: {},
  watch: {},
  methods: {
    changeShow() {
      this.show = !this.show;
    },
    openTask(item) {
      const { id, browseLink, browseTime, recommendId, taskType, isFinish } = item;
      sessionStorage.removeItem('cardPhoto')
      if (isFinish) return;
      this.currentTask = item;
      switch (taskType) {
        case 'LOOK1':
          console.log(334);
          this.openBrowse(id, browseLink, browseTime);
          break;
        case 'ORDER1':
          this.openRecommend(recommendId);
          break;
        case 'BASIC1':
          // 自媒体晒书
          sessionStorage.setItem('cardPhoto',1)
          this.openUplodImg(id);
          break;
        case 'BASIC2':
          //下载APP
          console.log(2222);
          this.changeShow();
          this.$refs.downApp.changeShow();
          break;
        case 'BASIC3':
          // 关注账号
          this.openOfficialAccount();
          break;
        case 'BASIC4':
          // 拉新
          this.openShare();
          break;
        default:
      }
    },
    // 打开推荐位列表
    openRecommend(recommendId) {
      this.$router.push({
        path: '/recommendList',
        query: { recId: recommendId, source: 'collectCard' },
      });
    },
    // 打开公众号
    openOfficialAccount() {
      console.log(3333, this.$refs.officialAccount.changeShow);
      this.changeShow();
      this.$refs.officialAccount.changeShow();
    },
    //拉新分享
    openShare() {
      this.changeShow();
      this.$refs.pullNew.changeShow();
    },
    // 浏览
    openBrowse(taskId, browseLink, browseTime) {
      // 携带活动ID 任务ID
      let url = '';
      if (browseLink.indexOf('?') > -1) {
        url = `${browseLink}&cardActivityId=${this.activityId}&cardTaskId=${taskId}&isBrowse=1&browseTime=${browseTime}`;
      } else {
        url = `${browseLink}?cardActivityId=${this.activityId}&cardTaskId=${taskId}&isBrowse=1&browseTime=${browseTime}`;
      }
      if (this.isApp) {
        this.changeShow();
        this.$sendToApp('openNewWebView', { url }, false);
      } else {
        window.location.assign(url);
      }
    },
    // 晒书
    openUplodImg(cardTaskId) {
      this.$router.push({
        path: '/cardphoto',
        query: { cardTaskId, cardActiveId: this.activityId },
      });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.task-list {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
  background: rgba($color: #000, $alpha: 0.5);
  .content {
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 45%;
    max-height: 70%;
    background: #f4f7fa;
    border-radius: 40px 40px 0 0;
    .title {
      position: relative;
      width: 100%;
      height: 158px;
      background: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/collectCard/task-title-bg.png');
      background-size: 100%;
      .box {
        width: 400px;
        height: 90px;
        margin: 0 auto;
        color: #2c2fbc;
        font-weight: 600;
        font-size: 32px;
        line-height: 90px;
        text-align: center;
        background: #d0d5ff;
        border-radius: 0 0 30px 30px;
      }
      .close {
        position: absolute;
        top: 30px;
        right: 30px;
        width: 40px;
        height: 40px;
        background: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/collectCard/close1.png');
        background-size: 100%;
      }
    }
    .section {
      flex: 1;
      width: 702px;
      height: 100%;
      height: 408px;
      margin: 0 auto 30px;
      padding-top: 40px;
      overflow-y: auto;
      background: #fff;
      border-radius: 20px;
      .list {
        display: flex;
        align-items: center;
        margin-bottom: 50px;
        padding: 0 20px;
        .icon {
          width: 76px;
          height: 76px;
          margin-right: 12px;
        }
        .desc {
          width: 400px;
          margin-right: 39px;
          h1 {
            width: 100%;
            padding-bottom: 6px;
            overflow: hidden;
            color: #464d64;
            font-weight: 600;
            font-size: 28px;
            line-height: 40px;
            white-space: nowrap;
            text-overflow: ellipsis;
            span {
              color: #464d64;
              font-weight: 600;
              font-size: 28px;
            }
          }
          h2 {
            width: 100%;
            overflow: hidden;
            color: rgba(99, 107, 141, 0.7);
            font-weight: 400;
            font-size: 22px;
            line-height: 30px;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
        .btn {
          min-width: 109px;
          height: 49px;
          color: #fff;
          font-weight: 500;
          font-size: 24px;
          line-height: 49px;
          background: linear-gradient(90deg, #ff8383 0%, #ff3838 100%);
          border-radius: 24px;
        }
        .btn.disabled {
          background: #d2dbe5 !important;
        }
      }
    }
  }
  .emptyData {
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    align-items: center;
    margin: 0 auto 0;
    img {
      display: block;
      width: 370px;
      height: 272px;
      margin: 0 auto 0;
    }
    p {
      width: 100%;
      height: 31px;
      color: #000;
      font-weight: 400;
      font-size: 26px;
      line-height: 31px;
      text-align: center;
    }
  }
}
</style>
